export enum EntityTypes {
    Company = 1,
    Contact,
    Building,
    Opportunity,
    Department,
    ProductType,
    Account
}
